import { Action } from '../../../common/actions/core/action';
import { PackageThumbnail } from '../../../common/services/package/package.model';

export class OpenDoubleOptWarningDialogAction implements Action {
  constructor(
    public approve: () => void,
    public relatedPackage:PackageThumbnail,
    public description: string) {}
}



// WEBPACK FOOTER //
// src/app/components/double-opt-dialog/warning/double-opt-warning-dialog.action.ts